import styled from 'styled-components';
import {Link} from 'react-router-dom';

export const PageWrapper = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 24px;
  color: #000;
  font-family: OpenSans, sans-serif;
  font-size: 16px;
  font-style: normal;
  position: relative;
  & .ScrollTopButton{
    position: fixed;
    bottom: 65px;
    right: 5%;
    z-index: 100;
    background-color: white;
  }
  @media screen and (min-width: 768px) {
    padding: 0 40px;
  }
`

export const H1 = styled.h1`
  font-family: Manrope, sans-serif;
  font-weight: 600;
  text-align: center;
  font-size: 36px;
  line-height: 54px;
  margin-top: 20px;
`

export const H3 = styled.h3`
  font-family: Manrope, sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 40px;
  margin-top: 30px;
  margin-bottom: 15px;
`

export const H4 = styled.h4`
  font-family: Manrope, sans-serif;
  font-size: 22px;
  font-weight: 500;
  line-height: 40px;
  margin-bottom: 10px;
  margin-top: 30px;
`

export const Subtitle = styled.div`
  font-weight: 400;
  font-size: 18px;
  color: #2c2b48;
  margin-bottom: 45px;
  margin-top: 30px;
`

export const Paragraph = styled.p`
  line-height: 28px;
`

export const PageLink = styled(Link)`
  font-family: Manrope, sans-serif;
  font-weight: 600;
  line-height: 24px;
  color: #0039bb;
  display: block;
  margin-bottom: 10px;
`

export const ListsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const List = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`

export const ListItem = styled.li`
  line-height: 28px;
  font-size: 16px;
  &.ListTitle{
    font-style: italic;
    text-decoration: underline;
  }
`

export const Img = styled.img`
  height: 190px;
  width: auto;
  margin-top: 30px;
  margin-bottom: 30px;
`

export const CenteredImageContainer = styled.div`
  text-align: center;
  & img {
    height: auto;
    max-width: 100%;
    vertical-align: middle;
  }
`

export const Icon = styled.img`
  height: 24px;
  width: 24px;
`

export const Heading = styled.div`
  text-align: center;
`
export const Pre = styled.div`
  white-space: pre-line;
`

export const Font600 = styled.span`
  font-weight: 600;
`
export const ScrollTopIcon = styled.img`
  height: 48px;
  width: 48px;
`

export const BulletList = styled.ul`
  margin-bottom: 2rem;
`

export const BulletListItem = styled.li`
  line-height: 28px;
  font-size: 16px;
  text-align: justify;
`